import { differenceInYears, format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import {
  Autocomplete,
  Checkbox,
  DatePickerMui,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  TextField
} from "../../../../components";
import { value } from "../../../../helpers";
import {
  PessoaService,
  SessionService,
} from "../../../../services";
import GrupoPessoaService from "../../../../services/api/grupoPessoas.service";
import { responseErros, timeoutBuscaAutocomplete } from "../../../../utils";
import { useFiltrosRelatoriosHandlers } from "../../components/use-filtros-relatorios-handlers";

const pessoaService = new PessoaService();
const sessionService = new SessionService();
const gruposPessoasService = new GrupoPessoaService();

const FormFiltroAvancadoVendasCliente = ({
  filtrosAvancados,
  setFiltrosAvancados,
  filtrosAplicadosImpressao,
  setFiltrosAplicadosImpressao,
  setValidationError
}) => {
  const inputRefCliente = useRef();
  const inputRefVendedor = useRef();
  const [clienteList, setClienteList] = useState([]);
  const [vendedorList, setVendedorList] = useState([]);
  const [grupoPessoasList, setGrupoPessoasList] = useState([]);
  // const [condicaoPagamentoList, setCondicaoPagamentoList] = useState([]);
  // const [meioPagamentoList, setMeioPagamentoList] = useState([]);
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);
  const usuario = sessionService.getUsuario();
  const empresa = sessionService.getEmpresa();
  const { 
    onChangeAutocomplete, 
    onChangeDate, 
    onChangeCheckbox, 
    onChangeInput
  } = useFiltrosRelatoriosHandlers(
    setFiltrosAvancados,
    setFiltrosAplicadosImpressao
  );

  useEffect(() => {
    setEstadoInicial();
    // buscarCondicoesPagamento();
    // buscarMeiosPagamento();
    buscarGruposPessoas();
  }, []);

  function setEstadoInicial() {
    const date = new Date();
    const inicioMes = new Date(date.getFullYear(), date.getMonth(), 1);
    const fimMes = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    const filtros = {
      ...filtrosAvancados,
      empresasIds: [empresa.id],
      dataEmissaoStart: inicioMes,
      dataEmissaoEnd: fimMes,
      ordenarPor: 'codigo',
      porIntervalo: [
        {
          coluna: 'dataEmissao',
          de: inicioMes,
          ate: fimMes,
        },
      ]
    };
    
    let filtrosImpressao = {
      ...filtrosAplicadosImpressao,
      ["Data-Inicial"]: format(inicioMes, "dd/MM/yyyy"),
      ["Data-Final"]: format(fimMes, "dd/MM/yyyy")
    };
    if (usuario.acessosEmpresas?.length) {
      filtrosImpressao = {
        ...filtrosImpressao,
        ["Empresas-Associadas"]: empresa.razaoSocial,
      };
    }

    setFiltrosAvancados(filtros);
    setFiltrosAplicadosImpressao(filtrosImpressao);
  }

  const buscarClientes = () => {
    const filtros = {
      nonPaginated: true,
      tiposPessoaId: 1,
    };
    pessoaService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setClienteList(result.data);
      } else {
        responseErros(result);
      }
    });
    setLoadingAutoComplete(false);
  };

  const buscarVendedores = () => {
    const filtro = {
      nonPaginated: true,
      vendedor: true,
      tiposPessoaId: 4,
    };
    pessoaService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setVendedorList(result.data);
      } else {
        responseErros(result);
      }
    });
    setLoadingAutoComplete(false);
  };

  // const buscarCondicoesPagamento = () => {
  //   condicaoPagamentoService.getAll({ ativado: true }).then((result) => {
  //     if (!result.isAxiosError) {
  //       setCondicaoPagamentoList(result.data.rows);
  //     } else {
  //       responseErros(result);
  //     }
  //   });
  // };

  // const buscarMeiosPagamento = () => {
  //   meioPagamentoService.getAll({ ativado: true }).then((result) => {
  //     if (!result.isAxiosError) {
  //       setMeioPagamentoList(result.data.rows);
  //     } else {
  //       responseErros(result);
  //     }
  //   });
  // };

  const buscarGruposPessoas = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
      tipoPessoa: 4
    };
    gruposPessoasService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setGrupoPessoasList(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const onInputChangePessoa = (event, tiposPessoaId) => {
    const inputRefMap = {
      1: {
        inputRef: inputRefCliente,
        buscar: buscarClientes,
      },
      4: {
        inputRef: inputRefVendedor,
        buscar: buscarVendedores,
      },
    };
    const { inputRef, buscar } = inputRefMap[tiposPessoaId] || {};
    if (
      event.key === "Enter" &&
      inputRef?.current === document.activeElement &&
      event.target?.value?.length > 2
    ) {
      setLoadingAutoComplete(true);
      const filtros = {
        nomeRazaoSocial: event.target.value,
        apelidoFantasia: event.target.value,
      };
      timeoutBuscaAutocomplete(buscar?.(filtros));
    }
  };

  function onChangeMultipleEmpresas(empresas) {
    setFiltrosAvancados((prevState) => ({
      ...prevState,
      empresasIds: empresas.map(({ id }) => id),
    }));
    setFiltrosAplicadosImpressao((prevState) => ({
      ...prevState,
      "Empresas-Associadas": empresas
        .map(({ razaoSocial }) => razaoSocial)
        .join(" | "),
    }));
  }

  function handleDateChangeError(dataInicio, dataFim, name) {
    const diferencaAnos = differenceInYears(new Date(dataFim), new Date(dataInicio));
    if (diferencaAnos >= 1) {
      setValidationError((prevState) => [...prevState, name]);
      return;
    } else {
      const errorNames = ["Data Emissão De", "Data Emissão Até"];
      setValidationError((prevState) => prevState.filter(item => !errorNames.includes(item)));
    }
  }

  return (
    <>
      {usuario.acessosEmpresas?.length > 0 && (
        <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Autocomplete
              multiple
              id="empresasIds"
              name="empresasIds"
              options={usuario.acessosEmpresas}
              noOptionsText="Sem opções"
              autoHighlight
              disablePortal
              filterSelectedOptions
              getOptionLabel={(option) => option?.razaoSocial || ""}
              onChange={(_, newValue) => onChangeMultipleEmpresas(newValue)}
              value={value.multiple(
                usuario.acessosEmpresas || [],
                filtrosAvancados["empresasIds"]
                  ? filtrosAvancados["empresasIds"]
                  : ""
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  required
                  label="Empresas"
                  margin="normal"
                />
              )}
            />
          </Grid>
        </Grid>
        <Divider sx={{ mt: 2, mb: 1, border: "1px solid grey" }}/>
        </>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="clienteId"
              name="Cliente"
              options={clienteList}
              autoHighlight
              disablePortal
              getOptionLabel={(option) => option?.nomeRazaoSocial ?? ""}
              getOptionSelected={(option, value) =>
                option?.nomeRazaoSocial === value?.nomeRazaoSocial
              }
              loading={loadingAutoComplete}
              loadingText="Carregando"
              noOptionsText="Digite e pressione Enter"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Cliente"
                  variant="outlined"
                  onKeyDown={(e) => onInputChangePessoa(e, 1)}
                  inputRef={inputRefCliente}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
              onChange={(e, value) =>
                onChangeAutocomplete("clienteId", value, "Cliente")
              }
              value={value.autoComplete(
                clienteList,
                filtrosAvancados?.clienteId
              )}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="vendedorId"
              name="Vendedor"
              options={vendedorList}
              autoHighlight
              disablePortal
              getOptionLabel={(option) => option?.nomeRazaoSocial ?? ""}
              getOptionSelected={(option, value) =>
                option?.nomeRazaoSocial === value?.nomeRazaoSocial
              }
              loading={loadingAutoComplete}
              loadingText="Carregando"
              noOptionsText="Digite e pressione Enter"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Vendedor"
                  variant="outlined"
                  onKeyDown={(e) => onInputChangePessoa(e, 4)}
                  inputRef={inputRefVendedor}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
              onChange={(e, value) =>
                onChangeAutocomplete("vendedorId", value, "Vendedor")
              }
              value={value.autoComplete(
                vendedorList,
                filtrosAvancados?.vendedorId
              )}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="grupoPessoaId"
              name="grupoPessoaId"
              options={grupoPessoasList}
              autoHighlight
              disablePortal
              getOptionLabel={(option) => option?.nome ?? ""}
              getOptionSelected={(option, value) =>
                option?.nome === value?.nome
              }
              loading={loadingAutoComplete}
              loadingText="Carregando"
              noOptionsText="Digite e pressione Enter"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Grupo de Pessoas"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
              onChange={(e, value) =>
                onChangeAutocomplete("grupoPessoaId", value, "Grupo-de-Pessoas")
              }
              value={value.autoComplete(
                grupoPessoasList,
                filtrosAvancados?.grupoPessoaId
              )}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <DatePickerMui
            id="dataEmissaoStart"
            name="dataEmissaoStart"
            label="Data Emissao De"
            format="MM/yyyy"
            views={["month", "year"]}
            variant="outlined"
            margin
            value={value.date(filtrosAvancados?.dataEmissaoStart)}
            onChange={(date) => {
              const inicioMes = new Date(date.getFullYear(), date.getMonth(), 1);
              handleDateChangeError(inicioMes, filtrosAvancados?.dataEmissaoEnd, "Data Emissão De");
              onChangeDate("dataEmissaoStart", inicioMes, "Data-Inicial");
            }}
            slotProps={{
              popper: { sx: { zIndex: 2000 }, }
            }}
            setError={setValidationError}
          />
        </Grid>
        <Grid item xs={6}>
          <DatePickerMui
            id="dataEmissaoEnd"
            name="dataEmissaoEnd"
            label="Data Emissao Até"
            format="MM/yyyy"
            views={["month", "year"]}
            variant="outlined"
            margin
            value={value.date(filtrosAvancados?.dataEmissaoEnd)}
            onChange={(date) => {
              const fimMes = new Date(date.getFullYear(), date.getMonth() + 1, 0);
              handleDateChangeError(filtrosAvancados?.dataEmissaoStart, fimMes, "Data Emissão Até");
              onChangeDate("dataEmissaoEnd", fimMes, "Data-Final");
            }}
            slotProps={{
              popper: { sx: { zIndex: 2000 }, }
            }}
            setError={setValidationError}
          />
        </Grid>
      </Grid>
      <Divider sx={{ mt: 2, mb: 1, border: "1px solid grey" }} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Select
            id="ordenarPor"
            name="ordenarPor"
            margin="normal"
            value={value.text(filtrosAvancados?.ordenarPor)}
            label="Ordenar Por"
            onChange={(event) => onChangeInput(event, "ordenarPor")}
            fullWidth
            SelectProps={{
              MenuProps: {
                disablePortal: true,
                PaperProps: {
                  sx: {
                    zIndex: 1600,
                  },
                },
              },
            }}
          >
            <MenuItem value={"codigo"}>Numérica</MenuItem>
            <MenuItem value={"nomeCliente"}>Alfabética</MenuItem>
          </Select>
        </Grid>
      </Grid>
      <Divider sx={{ mt: 2, mb: 1, border: "1px solid grey" }} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControlLabel
            label="Apenas o que é gerado para Contas a Receber"
            labelPlacement="end"
            control={
              <Checkbox
                name="geraContasReceber"
                checked={filtrosAvancados?.geraContasReceber}
                onChange={(event) =>
                  onChangeCheckbox(event, "Apenas-Gerado-Contas-Receber")
                }
                color="primary"
              />
            }
          />
        </Grid>
        {empresa.moduloServico &&
         <Grid item xs={12}>
          <FormControlLabel
            label="Considerar Ordem de Serviço"
            labelPlacement="end"
            control={
              <Checkbox
                name="ordemServico"
                checked={filtrosAvancados?.ordemServico}
                onChange={(event) =>
                  onChangeCheckbox(event, "Ordem-Servico")
                }
                color="primary"
              />
            }
          />
        </Grid>
        }
      </Grid>
    </>
  );
};

export default FormFiltroAvancadoVendasCliente;
